/* eslint-disable react/no-unknown-property */
/* eslint-disable max-len */
import React from 'react';

/**
 * DollarSignIcon - Auto-generated from icon.js
 */
export const DollarSignIcon = (props: React.SVGProps<SVGSVGElement>): JSX.Element => (
	<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path d="M12 4L12 20" stroke="#333333" strokeLinecap="round" strokeLinejoin="round" />
		<path d="M16.0232 6.32757H9.87102C9.10958 6.32757 8.37932 6.63005 7.8409 7.16847C7.30248 7.70689 7 8.43715 7 9.19859C7 9.96003 7.30248 10.6903 7.8409 11.2287C8.37932 11.7671 9.10958 12.0696 9.87102 12.0696H13.9725C14.7339 12.0696 15.4642 12.3721 16.0026 12.9105C16.541 13.4489 16.8435 14.1792 16.8435 14.9406C16.8435 15.7021 16.541 16.4323 16.0026 16.9707C15.4642 17.5092 14.7339 17.8116 13.9725 17.8116H7" stroke="#333333" strokeLinecap="round" strokeLinejoin="round" />
	</svg>
);

export default DollarSignIcon;
